export default "__VITE_ASSET__85313555__"